import { useMutation, useQuery } from '@tanstack/react-query';
import {
  getBillingStatus,
  createCheckoutSession,
  createPortalSession,
} from '../api/billingApi';
import { PlanType } from '../utils/planConfig';

export const billingStatusKey = ['billingStatus'] as const;

export function useBillingStatus() {
  return useQuery({
    queryKey: billingStatusKey,
    queryFn: getBillingStatus,
  });
}

export function useCheckout() {
  return useMutation({
    mutationFn: ({ plan, seats }: { plan: PlanType; seats?: number }) =>
      createCheckoutSession(plan, seats),
    onSuccess: (data) => {
      if (data.url) window.location.href = data.url;
    },
  });
}

export function useBillingPortal() {
  return useMutation({
    mutationFn: createPortalSession,
    onSuccess: (data) => {
      if (data.url) window.location.href = data.url;
    },
  });
}
